import React, { useState } from 'react';

import SaveButton from '../../../components/SaveButton';
import { gql, useQuery, useMutation } from '@apollo/client';

import useNotifier from '../../../hooks/useNotifier';
import { ListingWebsite_UpdateData } from '../../../types/graph/ListingWebsite_UpdateData';
import ListingDeleteModal from '../ListingDeleteModal';
import { ListingDetails_ListingData_listing } from '../../../types/graph/ListingDetails_ListingData';
import Styling, { IStylingValues } from './Website/Styling';
import Domain from './Website/Domain';

interface IProps {
  listing: ListingDetails_ListingData_listing;
}

const Website: React.FC<IProps> = ({ listing }) => {
  const notifier = useNotifier();
  const [updating, setUpdating] = useState<boolean>(false);

  const [updateWebsite] = useMutation<ListingWebsite_UpdateData>(
    WEBSITE_UPDATE_QUERY,
    {
      onCompleted: () => {
        setUpdating(false);
        notifier.showMessage(
          'Successfully saved!',
          'Website has been updated.',
          'success'
        );
      },
    }
  );

  const onStylingChange = (values: IStylingValues) => {
    setUpdating(true);
    updateWebsite({
      variables: {
        listingId: listing.id,
        listing: { website: { styling: { ...values } } },
      },
    });
  };

  return (
    <div>
      <form>
        <div className="space-y-6">
          <div className="bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
            <Styling listing={listing} onChange={onStylingChange} />
          </div>
          <div className="bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
            <Domain listing={listing} />
          </div>
          {/* <div className="flex justify-end">
            <button
              type="button"
              className="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-light"
            >
              Cancel
            </button>
            <SaveButton loading={false} />
          </div> */}
        </div>
      </form>
    </div>
  );
};

export default Website;

const WEBSITE_UPDATE_QUERY = gql`
  mutation ListingWebsite_UpdateData(
    $listingId: String!
    $listing: ListingInput!
  ) {
    listingUpdate(listingId: $listingId, listing: $listing) {
      id
      property {
        address {
          street
          city
          region
          postal
          country
          lat
          lng
        }
        media {
          sid
          filePath
        }
      }
      website {
        styling {
          template
          colors {
            primary
            accent
          }
        }
      }
      contacts {
        id
        person {
          name {
            first
            last
            full
          }
          email
          phones {
            number
            type
          }
          socialLinks {
            url
            type
          }
          avatar {
            filePath
          }
        }
        company {
          name
          title
          socialLinks {
            url
            type
          }
          logo {
            filePath
          }
        }
      }
    }
  }
`;
